<script setup lang="ts">
import { CompanyInfoSelect, Mailing } from '@/@types/participant'
import Ticket from '@/components/shared/base_mailing/InfoTicket.vue'
import Form from '@/components/shared/participant/mailings/form/Index.vue'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import Title from '@/components/ui/title/Title.vue'
import LightLayout from '@/layouts/LightLayout.vue'
import { Head } from '@inertiajs/vue3'

const { mailing, company_info_select } = defineProps<{ mailing: Mailing; company_info_select: CompanyInfoSelect }>()
</script>

<template>
    <Head :title="$t('My ticket')"></Head>

    <LightLayout contentClasses="bg-slate-50">
        <main class="container grid gap-6 font-sans lg:grid-cols-3">
            <section class="lg:col-span-2">
                <Card class="border-none bg-white text-slate-800 shadow-[0_4px_12px_0px_rgba(12,12,13,.08)]">
                    <CardHeader>
                        <Title class="!text-2xl">
                            {{ $t('Complete ticket information') }}
                        </Title>
                        <p class="text-base !font-normal !text-slate-800">
                            {{ $t('By filling in all required fields and saving, your ticket will be generated automatically.') }}
                        </p>
                    </CardHeader>

                    <CardContent class="py-8">
                        <Form :mailing="mailing" :company_info_select="company_info_select" />
                    </CardContent>
                </Card>
            </section>

            <Ticket :mailing="mailing" />
        </main>
    </LightLayout>
</template>
